import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../shared/locales/no.json';

// TODO Add icon in a less hacky way
const iconExternal = (
    <svg
        aria-hidden="true"
        className="valign-top mls"
        height="16"
        viewBox="0 0 20 18"
        width="16"
    >
        <g fill="currentColor">
            <path d="M14 14.8V17H5V8h2.2l2-2H5c-1.312 0-2 .75-2 2.016V17c0 1.25.734 2 1.983 2h9c1.25 0 2.017-.78 2.017-1.984V12.8l-2 2z" />
            <path d="M19 3h-9l2.5 2.5-4.395 4.437 3.967 3.97L16.5 9.5 19 12" />
        </g>
    </svg>
);

const VALID_URL_PATTERN = /^\s*https?:\/\//i;

export default class ProfileHomePageLink extends PureComponent {
    static propTypes = {
        url: PropTypes.string,
    };

    render() {
        const { url, children } = this.props;
        const isUrlValid = VALID_URL_PATTERN.test(url);
        return isUrlValid || children ? (
            <p className="flex flex-wrap">
                {isUrlValid ? (
                    <a
                        className="u-pr16 flex"
                        href={url}
                        rel="noopener"
                        target="_blank"
                    >
                        {i18n.homePageLink.text}
                        {iconExternal}
                    </a>
                ) : (
                    <span className="u-pr16 u-sardine flex">
                        {i18n.homePageLink.text}
                        {iconExternal}
                    </span>
                )}
                {children}
            </p>
        ) : null;
    }
}
